// extracted by mini-css-extract-plugin
export default {"pageWidthS":"1000px","imageRatio":"1.5"};